var map = {
	"./icon_clap_up_dark.png": 308,
	"./icon_clap_up_white.png": 309
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 738;


//////////////////
// WEBPACK FOOTER
// ./src/modules/knowledge/components/images ^\.\/icon_clap_up_.*\.png$
// module id = 738
// module chunks = 0